(() => {
  const params = new URLSearchParams(window.location.search);
  if (params.get('customizer_method') !== 'generate' || params.has('customizer_edit') || params.has('cart_line')) return;

  let observer;
  let timeout;
  let finished = false;
  const stop = () => {
    finished = true;
    observer?.disconnect();
    clearTimeout(timeout);
    document.removeEventListener('click', onMethodClick, true);
    window.removeEventListener('pagehide', stop);
  };
  // A shopper's own choice always takes precedence while the editor loads.
  const onMethodClick = event => {
    if (event.target.closest?.('[data-customizer-method]')) stop();
  };
  const openGenerator = () => {
    if (finished) return;
    const root = document.querySelector('[data-customizer][data-gallery-ready="true"]');
    const button = root?.querySelector('[data-customizer-method="generate"]');
    if (!button || button.disabled) return;
    stop();
    if (button.getAttribute('aria-expanded') !== 'true') button.click();
  };

  document.addEventListener('click', onMethodClick, true);
  window.addEventListener('pagehide', stop, { once: true });
  observer = new MutationObserver(openGenerator);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-gallery-ready'],
  });
  timeout = setTimeout(stop, 30000);
  openGenerator();
})();
